<template>
  <article class="trainers">

    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap fill-height>
          <v-flex xs12 lg5 class="head_contain">
            <p class="table_card__head--title">
              Locaciones
            </p>
          </v-flex>
          <v-flex xs12 lg7 class="filter_options">
            <v-flex class="right mr-20">
              <button
                class="faccess_button mr-20"
                @click="$router.push({name: 'holidays'})"
              >
                Cargar Festivos
              </button>
              <button
                class="faccess_button"
                @click="$router.push({name: 'location_new'})"
              >
                Crear nueva locación
              </button>
            </v-flex>
            <div
              class="buttom_reload"
              @click="findLocations()"
            >
              <img src="@/assets/img/icons/refresh-icon.svg">
            </div>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__body pl-0">
        <v-layout row wrap fill-height>
          <template
            v-for="location in locations"
          >
            <v-flex
              :key="location.id"
              xs12 lg4
            >
              <card-location
                :location="location"
                v-on:select-location="selectLocation"
                v-on:locker-modal="openLockersModal"
              ></card-location>
            </v-flex>
          </template>

        </v-layout>
      </div>
      <div class="table_card__footer justify-content-start">
        <nav class="pagination" role="navegation" aria-label="pagination">
          <v-pagination
            :value ="page"
            :length="pages"
            @input ="changePage"
          />
        </nav>
      </div>
    </div>
    <qr-modal
      v-if="show_qr_modal"
      :qr_text="location_selected"
      :location_name="location_name"
      @closeQrModal="resetQrModal()"
    >
    </qr-modal>
    <locker-sublocation-modal 
      v-if="show_lockers_modal"
      :location_id="locker_location_selected"
      @close-locker-modal="closeLockerModal()">
    </locker-sublocation-modal>
  </article>
</template>

<script>

import cardLocation from '../../shared/LocationItem.vue'

export default {
  data(){
    return{
      locations:[],
      location_selected: null,      
      show_qr_modal: false,
      show_lockers_modal: false,
      locker_location_selected: null,
      location_name: '',
      page: 1,
      pages: 1
    }
  },
  components: {
    cardLocation
  },
  methods:{
    selectLocation(object){
      this.location_selected = object.id;
      this.location_name = object.attributes.name
      this.show_qr_modal = true;
    },
    resetQrModal(){
      this.show_qr_modal = false;
      this.location_selected = null;
    },
    deleteLocation(id){
      try {
        this.$http.delete('locations/'+id,
        {headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()}})
        .then(function(response){
          for (var i = 0; i < this.locations.length; i++) {
            if(this.locations[i].id == id){
              this.locations.splice(i, 1)
            }
          }
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    findLocations(){
      let params = { page: this.page }
      const data={company:{id:this.getCompany().id}}
      try {
        this.$http.post('locations/company',{data:this.encrypt(data).toString()},{
          headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()},
           params
        })
        .then(function(response){
          this.locations = response.body.data
          this.updateLocations(response.body.data)
          console.log('======log========')
          console.log('locations',response.body.data);
          this.pages = response.body.meta.pages
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    changePage (page){
      console.log('====logPage=====')
      console.log(page)
      this.page = page
      this.findLocations();
    },
    openLockersModal(location){
      this.show_lockers_modal = true
      this.locker_location_selected = parseInt(location.id)
    },
    closeLockerModal(){
      this.show_lockers_modal = false
    }
  },
  mounted(){
    this.findLocations()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/locations/Index.vue